import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '@blueprint/ui';

export const Container = styled('div')(
    ({ theme: { mq } }) => css`
        position: relative;
        margin: 0.5rem 0 0 0;

        ${mq.large} {
            margin: 0 0 1.25rem 0;
        }
    `
);

export const Overlay = styled('div')(
    ({ theme: { colors } }) => css`
        position: absolute;
        top: 0;
        width: 100%;
        background: ${colors['graphic-background-accent-light']};
    `
);

export const StyledLink = styled(Link)(
    ({ theme: { mq, spacing } }) => css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        ${mq.large} {
            justify-content: center;
        }

        svg {
            margin-right: ${spacing['8px']};
        }
    `
);
